import { useApi } from "./useApi";

/**
 * UX-Paket 26.08.2026, Punkt 3: der Mandanten-Firmenname, mandantenfähig statt hardcoded ("Ristorante
 * Storia" ist NUR der Name des Pilot-Betriebs, nicht jedes künftigen Mandanten). Lädt einmal über die
 * ohnehin vorhandene Route `GET /api/settings/payment-terms` (`TENANT_SETTINGS_SICHTBAR`-Projektion,
 * liefert u. a. `companyLegalName`) — kein neuer Endpunkt nötig. `null`, solange nicht geladen oder
 * beim Mandanten nicht gepflegt; Aufrufer entscheiden selbst über einen Anzeige-Fallback.
 */
export function useCompanyName(): string | null {
  const { data } = useApi<{ companyLegalName: string | null }>("/api/settings/payment-terms");
  return data?.companyLegalName ?? null;
}
